export default __webpack_public_path__ + "static/media/Ginger Tom with Whole Fish.e8633c55.png";